import React from "react";
import "./Card.css";
export const Price = () => {
  return (
    <div className="price-content">
      <span id="price">$149.99</span>
      <span id="price-off">$169.99</span>
    </div>
  );
};
